import { render, staticRenderFns } from "./DroppablePlaylist.vue?vue&type=template&id=0bb373c8"
import script from "./DroppablePlaylist.vue?vue&type=script&lang=js"
export * from "./DroppablePlaylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports